import { render, staticRenderFns } from "./nopermission.vue?vue&type=template&id=109a540f&scoped=true&"
import script from "./nopermission.vue?vue&type=script&lang=ts&"
export * from "./nopermission.vue?vue&type=script&lang=ts&"
import style0 from "./nopermission.vue?vue&type=style&index=0&id=109a540f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a540f",
  null
  
)

export default component.exports